import Controller from '@ember/controller';

export default class AuthenticatedProjectsController extends Controller {}
